import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoginBackgroundService {
  private showLoginBackgroundSub = new BehaviorSubject<boolean>(false);
  showLoginBackground$ = this.showLoginBackgroundSub.asObservable();

  set showLoginBackground(show: boolean) {
    this.showLoginBackgroundSub.next(show);
  }
}
